import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { t } from '../i18n';
import { DESIGNS, BG_COLORS, OCCASIONS, cardSvg } from '../cardDesigns';

const API = '/api/reminders';
function authHeaders() {
  const tok = localStorage.getItem('token');
  return { 'Content-Type': 'application/json', ...(tok ? { Authorization: `Token ${tok}` } : {}) };
}
const C = { ink: '#2C2C2A', muted: '#5F5E5A', border: '#E3E1D9', soft: '#F4F3EE', primary: '#0F6E56' };
const inp = { width: '100%', padding: '9px 11px', border: '0.5px solid #B4B2A9', borderRadius: 8, fontSize: 14, marginBottom: 10, fontFamily: 'inherit' };
const lbl = { fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 4, color: C.ink };
const btn = { fontSize: 14, padding: '10px 20px', border: 'none', borderRadius: 8, background: C.primary, color: '#fff', cursor: 'pointer', fontWeight: 600 };

export default function CardNew() {
  const [q] = useSearchParams();
  const [occasion, setOccasion] = useState(q.get('occasion') || 'birthday');
  const [design, setDesign] = useState('cake');
  const [bg, setBg] = useState('#E1F5EE');
  const [name, setName] = useState(q.get('to') || '');
  const [username, setUsername] = useState(q.get('username') || '');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [sent, setSent] = useState(null);

  // Mauqa badla to us ke munasib design
  useEffect(() => {
    const fit = DESIGNS.filter((d) => d.occasions.includes(occasion));
    if (fit.length && !fit.some((d) => d.key === design)) {
      setDesign(fit[0].key);
      setBg(fit[0].defaultBg);
    }
  }, [occasion]); // eslint-disable-line

  const occ = OCCASIONS.find((o) => o.key === occasion) || OCCASIONS[0];
  const preview = cardSvg(design, bg, occ.head, name ? `${t('card_for')} ${name}` : '');

  const send = async () => {
    if (!name.trim()) { setErr(t('card_need_name')); return; }
    if (!message.trim()) { setErr(t('card_need_message')); return; }
    setBusy(true); setErr('');
    try {
      const r = await fetch(`${API}/cards/send/`, {
        method: 'POST', headers: authHeaders(),
        body: JSON.stringify({ name, username, email, occasion, design, bg_color: bg, message }),
      });
      const d = await r.json();
      if (!r.ok || d.error) throw new Error(d.error || 'Failed');
      setSent(d);
    } catch (e) { setErr(e.message); }
    setBusy(false);
  };

  if (!localStorage.getItem('token')) {
    return <div style={{ padding: '1.5rem' }}><p style={{ fontSize: 13 }}>{t('cv_please_login')}</p></div>;
  }

  // ---------- bhej diya ----------
  if (sent) {
    return (
      <div style={{ padding: '1.25rem', maxWidth: 460, margin: '0 auto', textAlign: 'center' }}>
        <div style={{ maxWidth: 220, margin: '0 auto 18px' }} dangerouslySetInnerHTML={{ __html: preview }} />
        <h2 style={{ fontSize: 19, margin: '0 0 6px', color: C.ink }}>✅ {t('card_sent')}</h2>
        <p style={{ fontSize: 13, color: C.muted, margin: '0 0 18px' }}>
          {sent.delivered.includes('penflow') && `📬 ${t('card_via_penflow')}`}
          {sent.delivered.includes('penflow') && sent.delivered.includes('email') && ' · '}
          {sent.delivered.includes('email') && `📧 ${t('card_via_email')}`}
          {sent.delivered.length === 0 && t('card_via_link_only')}
        </p>

        <div style={{ background: C.soft, borderRadius: 10, padding: '12px', marginBottom: 12 }}>
          <p style={{ fontSize: 11, color: C.muted, margin: '0 0 6px' }}>{t('card_link_note')}</p>
          <p style={{ fontSize: 11.5, fontFamily: 'monospace', wordBreak: 'break-all', margin: '0 0 10px', color: C.ink }}>{sent.link}</p>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href={sent.whatsapp} target="_blank" rel="noopener noreferrer"
              style={{ ...btn, background: '#25D366', textDecoration: 'none', fontSize: 13, padding: '8px 16px' }}>
              🟢 {t('card_whatsapp')}
            </a>
            <button onClick={() => navigator.clipboard.writeText(sent.link)}
              style={{ ...btn, background: '#fff', color: C.ink, border: '0.5px solid #B4B2A9', fontSize: 13, padding: '8px 16px' }}>
              📋 {t('card_copy_link')}
            </button>
          </div>
        </div>

        <button onClick={() => { setSent(null); setName(''); setMessage(''); setEmail(''); setUsername(''); }}
          style={{ ...btn, background: '#fff', color: C.ink, border: '0.5px solid #B4B2A9' }}>
          {t('card_send_another')}
        </button>
      </div>
    );
  }

  // ---------- banao ----------
  return (
    <div style={{ padding: '1.25rem', maxWidth: 640, margin: '0 auto' }}>
      <h2 style={{ fontSize: 20, margin: '0 0 14px', color: C.ink }}>💌 {t('card_send_a_card')}</h2>

      <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
        <div style={{ flex: '1 1 200px', maxWidth: 240 }}>
          <div style={{ position: 'sticky', top: 16 }} dangerouslySetInnerHTML={{ __html: preview }} />
        </div>

        <div style={{ flex: '1 1 280px' }}>
          <label style={lbl}>{t('card_occasion')}</label>
          <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', marginBottom: 12 }}>
            {OCCASIONS.map((o) => (
              <button key={o.key} onClick={() => setOccasion(o.key)}
                style={{
                  fontSize: 12, padding: '5px 10px', borderRadius: 14, cursor: 'pointer',
                  border: occasion === o.key ? 'none' : '0.5px solid #B4B2A9',
                  background: occasion === o.key ? C.primary : '#fff',
                  color: occasion === o.key ? '#fff' : C.ink,
                  fontWeight: occasion === o.key ? 600 : 400,
                }}>{o.icon} {o.label}</button>
            ))}
          </div>

          <label style={lbl}>{t('card_design')}</label>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 12 }}>
            {DESIGNS.filter((d) => d.occasions.includes(occasion)).map((d) => (
              <button key={d.key} onClick={() => setDesign(d.key)}
                style={{
                  width: 52, height: 52, borderRadius: 8, cursor: 'pointer', padding: 3,
                  border: design === d.key ? `2px solid ${C.primary}` : '0.5px solid #B4B2A9',
                  background: '#fff',
                }}
                dangerouslySetInnerHTML={{ __html: cardSvg(d.key, d.defaultBg, '', '') }} />
            ))}
          </div>

          <label style={lbl}>{t('card_colour')}</label>
          <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', marginBottom: 14 }}>
            {BG_COLORS.map((col) => (
              <button key={col} onClick={() => setBg(col)} aria-label={col}
                style={{
                  width: 26, height: 26, borderRadius: '50%', cursor: 'pointer', background: col,
                  border: bg === col ? `2px solid ${C.primary}` : '0.5px solid #B4B2A9',
                }} />
            ))}
          </div>

          <label style={lbl}>{t('card_to_name')}</label>
          <input style={inp} value={name} onChange={(e) => setName(e.target.value)} maxLength={120} />

          <label style={lbl}>{t('card_username')}</label>
          <input style={inp} value={username} onChange={(e) => setUsername(e.target.value)} placeholder="username" />

          <label style={lbl}>{t('card_email')}</label>
          <input style={inp} type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="name@example.com" />
          <p style={{ fontSize: 11, color: C.muted, margin: '-6px 0 12px', lineHeight: 1.5 }}>{t('card_delivery_note')}</p>

          <label style={lbl}>{t('card_message')}</label>
          <textarea style={{ ...inp, minHeight: 100, resize: 'vertical', lineHeight: 1.6 }}
            value={message} onChange={(e) => setMessage(e.target.value)} maxLength={2000}
            placeholder={t('card_message_ph')} />

          {err && <p style={{ fontSize: 12.5, color: '#C0392B', margin: '0 0 10px' }}>{err}</p>}
          <button onClick={send} disabled={busy} style={btn}>{busy ? '…' : `💌 ${t('card_send')}`}</button>
        </div>
      </div>
    </div>
  );
}
